<template>
  <div>
    <h2 class="secondary--text mb-3 mt-5">Personal Content Marketing</h2>
    <div class="body-1 grey--text text--darken-2">
      Trustedaccountant.nl lanceert Personal Content Marketing.......
    </div>
  </div>
</template>

<script>
export default {
  name: "headerA",
};
</script>

<style scoped></style>
